var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-box" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center" },
        [
          _vm.showSpinner
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card",
        { staticClass: "mb-3" },
        [
          _c("b-card-header", [_vm._v("Complaint Information")]),
          _c(
            "b-card-body",
            [
              _c("ComplaintInfo", {
                attrs: { complaint: _vm.complaint, loading: _vm.loadingopp },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-card-header", [_vm._v("Feedback History")]),
          _c(
            "b-card-body",
            [_c("FeedbackHistory", { attrs: { complaint: _vm.complaint } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }